import React from 'react';
import DrawerForm from 'components/DrawerForm';
import { Input, Form, Radio, Space } from 'antd';
import ColorPicker from 'components/ColorPicker';
import QueryBuilderInput from 'components/QueryBuilder/QueryBuilderInput';
import PreviewDates from 'components/DateRangePicker/date-preview';
import DateRangePicker from 'components/DateRangePicker';
import { getDefaultDateRange } from 'shared/constants/date';

const dateRangeOptions = [
  { label: 'Main', value: 'main' },
  // { label: 'Previous period', value: COMPARE_PERIOD.PERIOD },
  // { label: 'Previous year', value: COMPARE_PERIOD.YEAR },
  { label: 'Custom', value: 'custom' },
];

const DateRangeInput = ({ value, onChange, globalDateRange }) => {
  let selectedDateRangeOption = 'main';

  if (value) {
    selectedDateRangeOption = 'custom';
  }

  const onDateRangeOptionChange = (e) => {
    const updated = e.target.value;
    if (updated === 'main') {
      onChange(null);
    } else {
      onChange(getDefaultDateRange());
    }
  };

  return (
    <>
      <Radio.Group
        options={dateRangeOptions.map(o => ({
          ...o,
          style: { width: '100%' },
          label: (
            <Space>
              {o.label}
              {o.value === 'main' && <PreviewDates dateRange={globalDateRange} />}
            </Space>
          ),
        }))}
        value={selectedDateRangeOption}
        onChange={onDateRangeOptionChange}
      />
      {selectedDateRangeOption === 'custom' && (
        <DateRangePicker
          onChange={onChange}
          value={value}
          defaultValue={null}
        />
      )}
    </>
  );
};

const EditSegmentDrawer = ({ open, segment, onSubmit, onRemove, onCancel, globalDateRange }) => (
  <DrawerForm
    open={open}
    onSubmit={onSubmit}
    onCancel={onCancel}
    title={segment?.title ? `Edit segment ${segment?.title}` : 'Edit segment'}
    initialValues={segment}
    onRemove={onRemove}
  >
    <Form.Item name="id" hidden>
      <Input />
    </Form.Item>
    <Form.Item label="Title" name="title" rules={[{ required: true }]}>
      <Input />
    </Form.Item>
    <Form.Item label="Color" name="color">
      <ColorPicker />
    </Form.Item>
    <Form.Item label="Date range" name="dateRangeConfig">
      <DateRangeInput globalDateRange={globalDateRange} />
    </Form.Item>
    <Form.Item label="Query" name="query">
      <QueryBuilderInput />
    </Form.Item>
  </DrawerForm>
);

export default EditSegmentDrawer;
